// Real purchases only — export these from your store (impultienda) orders.
// The notification stays hidden while this list is empty.
// Example entry: { firstName: 'Laura', location: 'Madrid, Spain', purchasedAt: '2026-10-08T14:32:00Z' }
export const recentPurchases: {
  firstName: string;
  location: string;
  purchasedAt: string;
}[] = [];
